/**
 * Licensed Materials - Property of IBM
 * IBM Watson (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import VisualizationPreviewList from './VisualizationPreviewList';
import DotsIndicator from './../util/DotsIndicator';
import classnames from 'classnames';

import './visPreviewList.scss';
import './visPreviewListSlider.scss';

@observer
class VisualizationPreviewListSlider extends Component {

	constructor(props) {
		super(props);
	}

	onDotClick(options){
		this.props.onDotClick && this.props.onDotClick(options);
	}

	render() {
		const classNames = classnames('vis-recommender__preview-slider', {
			'vis-recommender__preview-slider--horizontal': this.props.horizontal,
			'vis-recommender__preview-slider--vertical': !this.props.horizontal
		});

		return (
			<div className={classNames}>
				<DotsIndicator
					items={this.props.items}
					activeIndex={this.props.visStartingIndex}
					onDotClick={this.onDotClick.bind(this)}
				/>
				<VisualizationPreviewList
					onAddItem={this.props.onAddItem}
					onClickItem={this.props.onClickItem}
					items={this.props.items}
					visStartingIndex={this.props.visStartingIndex}
					maxDisplayedItems={1}
					enableSeeMore={false}
					predictData={this.props.predictData}
					isPredictPreview={this.props.isPredictPreview}
					model={this.props.model}
					horizontal={true}
					dashboardApi={this.props.dashboardApi}
					titleOnBottom={false}
					spinnerSize={'large'}
					featureSet={['vis-title-fetcher']}
					logger={this.props.logger}
				/>
			</div>
		);
	}

}

VisualizationPreviewListSlider.propTypes = {
	dashboardApi: PropTypes.object.isRequired,
	items: PropTypes.array.isRequired,
	onClickItem: PropTypes.func,
	onAddItem: PropTypes.func,
	horizontal: PropTypes.bool,
	predictData: PropTypes.object,
	isPredictPreview: PropTypes.bool,
	maxDisplayedItems: PropTypes.number,
	visStartingIndex: PropTypes.number,
	titleOnBottom: PropTypes.bool,
	enableSeeMore: PropTypes.bool,
	onGetMore: PropTypes.func,
	model: PropTypes.arrayOf(PropTypes.object),
	onDotClick: PropTypes.func,
	featureSet: PropTypes.array,
	logger: PropTypes.object
};

VisualizationPreviewListSlider.defaultProps = {
	horizontal: false,
	maxDisplayedItems: 1,
	visStartingIndex: 0,
	onAddItem: () => {},
	titleOnBottom: true,
	enableSeeMore: false
};

export default VisualizationPreviewListSlider;



// WEBPACK FOOTER //
// ./src/js/lib/@waca/vis-recommender/src/js/preview/VisualizationPreviewListSlider.js